import {
  useAvailabilitySlotTypes,
  TimeSlotTypeChip,
} from '@product-framework/index';

function DateCellContent({
  cellDateValue,
  textDate,
  gridKey,
  setSelectedDayAndSlot,
  setErrors,
}) {
  const { getSlotByCode } = useAvailabilitySlotTypes();

  const slots = Array.isArray(cellDateValue?.slots) ? cellDateValue.slots : [];

  if (cellDateValue?.available) {
    return slots.map(slotKey => {
      const slotFound = getSlotByCode({ code: slotKey.code });

      return (
        <TimeSlotTypeChip
          onClick={() => {
            setErrors(null);
            setSelectedDayAndSlot({ slot: slotKey, textDate });
          }}
          key={`${gridKey}${slotKey?.code}`}
          name={slotFound?.name || slotKey.code}
          code={slotKey.code}
        />
      );
    });
  }
  return null;
}

export default DateCellContent;
